import React, { Component } from "react";
import Button from "@acadia-ui/button";
import Dropdown from "@acadia-ui/dropdown";
import Textbox from "@acadia-ui/textbox";
import Modal from "@acadia-ui/modal";
import { showToast, TOAST_TYPE, ToastNotification } from "@acadia-ui/toast";
import LoadingIcon from "../../Components/LoadingSpinner";

import "./modal.scss";
import ModalHelpers from "./ModalHelpers";
import TableHelper from "../../Components/Table/TableHelper";

const initialState = {
	dataKeyToFind: null,
	dataValueToFind: null,
	selectableDataKeys: [],
	searchableDataValues: [],
	replaceableDataValues: [],
	totalSearchedDataPieces: [],
	fullDataSet: [],
	replacementDataValue: null,
	replacementFreeformValue: "",
	searchNotFound: false,
	indexOfCurrentFoundValue: 0,
	replaceMade: false
};

class FindReplaceModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			...initialState
		};

		const componentTypeMap = {
			AdSet: {
				IDName: "AdSetID",
				taxonomyPropertyName: "AdSetName"
			},
			Placement: {
				IDName: "PlacementID",
				taxonomyPropertyName: "PlacementName"
			},
			Package: {
				IDName: "PackageID",
				taxonomyPropertyName: "PackageName"
			},
			LineItem: {
				IDName: "LineItemID",
				taxonomyPropertyName: "LineItemName"
			},
			InsertionOrder: {
				IDName: "InsertionOrderID",
				taxonomyPropertyName: "InsertionOrderName"
			},
			Creative: {
				IDName: "CreativeID",
				taxonomyPropertyName: "CreativeName"
			}
		};

		const { IDName, taxonomyPropertyName } = componentTypeMap[this.props.type];

		this.IDName = IDName;
		this.taxonomyPropertyName = taxonomyPropertyName;
	}

	componentDidMount() {
		this.props.findReplaceModal(this);
	}

	componentWillUnmount() {
		this.props.findReplaceModal(undefined);
	}

	/* Needed for all Modals */
	triggerOpenClose = (event) => {
		ModalHelpers.openClose(event, this.updateModalState, this.state, initialState, () => {
			if (this.state.open === false || this.state.open === undefined) {
				this.filterDataKeys();
			} else {
				this.setState({ ...initialState });
			}
		});
	};

	modalCloseCheck = () => {
		this.setState({ ...initialState, open: false });
		TableHelper.clearHighlightedCells(this.props.hierarchyLevel);
		if (this.state.replaceMade === true) {
			showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.SUCCESS} message="Find & Replace completed successfully." timed={5000} />);
		}
	};

	updateModalState = () => {
		this.setState({ open: !this.state.open });
	};

	filterDataKeys = () => {
		if (this.props.config) {
			const tableData = this.props.tableRef.current.dataProvider.currentData;
			const selectableDataKeys = [];
			const parentDataKeyIds = [];
			const nonApplicableDataBuckets = ["RegEx", "ParentData", "ChildData"];
			Object.keys(this.props.config).forEach((dataBucket) => {
				if (!nonApplicableDataBuckets.includes(dataBucket)) {
					this.props.config[dataBucket].forEach((dataKey) => {
						if (dataKey.ParentName !== null) {
							parentDataKeyIds.push(dataKey.ParentName);
						}
					});
				}
			});
			Object.keys(this.props.config).forEach((dataBucket) => {
				if (!nonApplicableDataBuckets.includes(dataBucket)) {
					this.props.config[dataBucket].forEach((dataKey) => {
						// Name based exclusion of in name site and rate type. Might need id based in the future
						if (
							dataKey.Name !== "InNameSite" &&
							dataKey.Name !== "Partner" &&
							dataKey.Name !== "RateType" &&
							dataKey.Name !== "EndDate" &&
							dataKey.Name !== "StartDate" &&
							dataKey.ParentName == null &&
							!parentDataKeyIds.includes(dataKey.Name)
						) {
							if (dataKey.DataType === "Select") {
								selectableDataKeys.push({
									label: dataKey.Label,
									value: dataKey.ID,
									dataBucket,
									name: dataKey.Name,
									type: "select"
								});
							} else if (dataKey.DataType === "String" && dataKey.FieldType !== "Hidden") {
								let freeFormOptions = [];
								tableData?.forEach((dataPiece) => {
									if (dataPiece[dataKey.Name] !== null && dataPiece[dataKey.Name] !== undefined && !freeFormOptions.includes(dataPiece[dataKey.Name])) {
										freeFormOptions.push(dataPiece[dataKey.Name]);
									}
								});
								freeFormOptions = freeFormOptions.map((freeFormField) => {
									return { OptionLabel: freeFormField };
								});
								selectableDataKeys.push({
									label: dataKey.Label,
									value: dataKey.ID,
									dataBucket,
									dataKeyOptions: freeFormOptions,
									name: dataKey.Name,
									type: "freeform"
								});
							}
						}
					});
				}
			});
			const dataCopy = JSON.parse(JSON.stringify(tableData));
			this.setState({ selectableDataKeys, fullDataSet: dataCopy });
		}
	};

	selectDataKey = (value) => {
		this.setState({ dataKeyToFind: value }, () => {
			if (value !== null) {
				this.props.config[value.dataBucket].forEach((dataKey) => {
					if (dataKey.ID === value.value) {
						if (dataKey.DataType === "Select") {
							let searchableDataValues = [];
							const replaceableDataValues = [];
							dataKey.Options.forEach((option) => {
								replaceableDataValues.push({ label: option.OptionLabel, value: option.OptionID });
							});
							let nullOption = false;
							this.state.fullDataSet.forEach((dataPiece) => {
								if (dataPiece[this.IDName] !== null && dataPiece[this.IDName] !== undefined) {
									if (dataPiece[dataKey.Name] !== null && dataPiece[dataKey.Name] !== undefined && !searchableDataValues.includes(dataPiece[dataKey.Name])) {
										searchableDataValues.push(dataPiece[dataKey.Name]);
									} else if (dataPiece[dataKey.Name] === null || dataPiece[dataKey.Name] === undefined) {
										nullOption = true;
									}
								}
							});
							if (nullOption === true) {
								searchableDataValues.unshift("(null)");
							}
							searchableDataValues = searchableDataValues.map((field) => {
								return { label: field, value: field };
							});
							this.setState({
								searchableDataValues,
								replaceableDataValues,
								dataValueToFind: null,
								totalSearchedDataPieces: [],
								replacementDataValue: null,
								replacementFreeformValue: "",
								searchNotFound: false,
								indexOfCurrentFoundValue: 0
							});
						} else if (dataKey.DataType === "String" && dataKey.FieldType !== "Hidden") {
							let searchableDataValues = [];
							let nullOption = false;
							this.state.fullDataSet.forEach((dataPiece) => {
								if (dataPiece[this.IDName] !== null && dataPiece[this.IDName] !== undefined) {
									if (dataPiece[dataKey.Name] !== null && dataPiece[dataKey.Name] !== undefined && !searchableDataValues.includes(dataPiece[dataKey.Name])) {
										searchableDataValues.push(dataPiece[dataKey.Name]);
									} else if (dataPiece[dataKey.Name] === null || dataPiece[dataKey.Name] === undefined) {
										nullOption = true;
									}
								}
							});
							if (nullOption === true) {
								searchableDataValues.unshift("(null)");
							}
							searchableDataValues = searchableDataValues.map((freeFormField) => {
								return { label: freeFormField, value: freeFormField };
							});
							this.setState({
								searchableDataValues,
								replaceableDataValues: [],
								dataValueToFind: null,
								totalSearchedDataPieces: [],
								replacementDataValue: null,
								replacementFreeformValue: "",
								searchNotFound: false,
								indexOfCurrentFoundValue: 0
							});
						}
					}
				});
			} else {
				this.setState({
					searchableDataValues: [],
					replaceableDataValues: [],
					dataValueToFind: null,
					totalSearchedDataPieces: [],
					replacementDataValue: null,
					replacementFreeformValue: "",
					searchNotFound: false,
					indexOfCurrentFoundValue: 0
				});
			}
		});
	};

	searchDataValue = (value) => {
		TableHelper.clearHighlightedCells(this.props.hierarchyLevel);
		this.setState({ dataValueToFind: value }, () => {
			if (value !== null) {
				const totalSearchedDataPieces = [];
				this.state.fullDataSet.forEach((dataPiece) => {
					if (dataPiece[this.IDName] !== null && dataPiece[this.IDName] !== undefined) {
						if (value.label !== "(null)") {
							if (this.state.dataKeyToFind.type == "select") {
								// match entire string for dropdown-driven find/replace
								if (dataPiece[this.state.dataKeyToFind.name] === value.label) {
									totalSearchedDataPieces.push(dataPiece);
								}
							} else {
								// match substrings for freeform-driven find/replace
								if (dataPiece[this.state.dataKeyToFind.name]?.includes(value.label)) {
									totalSearchedDataPieces.push(dataPiece);
								}
							}
						} else if (Object.keys(dataPiece).length > 0) {
							if (dataPiece[this.state.dataKeyToFind.name] === "" || !dataPiece[this.state.dataKeyToFind.name]) {
								totalSearchedDataPieces.push(dataPiece);
							}
						}
					}
					// Maybe need a check to see if the data key name has been updated and no longer matches existing field in the data piece
				});

				this.setState({
					searchNotFound: totalSearchedDataPieces.length == 0,
					totalSearchedDataPieces,
					replacementDataValue: null,
					replacementFreeformValue: "",
					indexOfCurrentFoundValue: 0
				});
				totalSearchedDataPieces.forEach((data) => {
					TableHelper.highlightCell(this.props.hierarchyLevel, data.UniqueID, this.state.dataKeyToFind?.name);
				});
			} else {
				this.setState({
					totalSearchedDataPieces: [],
					replacementDataValue: null,
					replacementFreeformValue: "",
					indexOfCurrentFoundValue: 0
				});
			}
		});
	};

	checkIfReplaceEmpty = () => {
		if (this.state.dataKeyToFind !== null) {
			if (this.state.dataKeyToFind.type === "select") {
				if (this.state.replacementDataValue !== null) {
					return false;
				}
				return true;
			}
			if (this.state.dataKeyToFind.type === "freeform") {
				if (/\S/.test(this.state.replacementFreeformValue)) {
					return false;
				}
				return true;
			}
		} else {
			return true;
		}
	};

	filterOutSelectedValue = (options, type) => {
		if (type === "selectableDataKeys") {
			if (this.state.dataKeyToFind !== null) {
				const filteredDataKeyList = options.filter((dataKey) => {
					return dataKey.value !== this.state.dataKeyToFind.value;
				});
				return filteredDataKeyList;
			}
			return options;
		}
		if (type === "searchableDataValues") {
			if (this.state.dataValueToFind !== null) {
				const filteredDataValueList = options.filter((dataValue) => {
					return dataValue.label !== this.state.dataValueToFind.label;
				});
				return filteredDataValueList;
			}
			return options;
		}
		if (type === "searchableReplacementDataValues") {
			if (this.state.dataValueToFind !== null) {
				let filteredDataValueList = options.filter((dataValue) => {
					return dataValue.label !== this.state.dataValueToFind.label && dataValue.label !== "(null)";
				});
				if (this.state.replacementDataValue !== null) {
					filteredDataValueList = filteredDataValueList.filter((dataValue) => {
						return dataValue.label !== this.state.replacementDataValue.label;
					});
				}
				return filteredDataValueList;
			}
		}
	};

	findMatchingValue = (findNext = false) => {
		let newIndex = this.state.indexOfCurrentFoundValue;
		if (findNext) {
			if (newIndex + 1 < this.state.totalSearchedDataPieces.length) {
				newIndex += 1;
			} else {
				newIndex = 0;
			}
			this.setState({ indexOfCurrentFoundValue: newIndex });
		}
		const matchingRow = this.state.fullDataSet.find((row) => {
			return row[this.IDName] === this.state.totalSearchedDataPieces[newIndex][this.IDName];
		});
		const rowId = matchingRow.UniqueID;
		// this.props.tableRef?.current?.focusCell(rowId, this.state.dataKeyToFind.name);
		setTimeout(() => {
			this.state.totalSearchedDataPieces.forEach((data) => {
				TableHelper.highlightCell(this.props.hierarchyLevel, data.UniqueID, this.state.dataKeyToFind?.name);
			});
			TableHelper.outlineCell(this.props.hierarchyLevel, rowId, this.state.dataKeyToFind.name);
		}, 100);
	};

	replaceValue = (replaceAll = false) => {
		let reapplyHighlightAfterFirstReplace = false;
		if (this.state.replaceMade !== true) {
			this.setState({ replaceMade: true });
			reapplyHighlightAfterFirstReplace = true;
		}
		const selectedRow = this.state.totalSearchedDataPieces[this.state.indexOfCurrentFoundValue];
		const rowIdsToReplace = replaceAll ? new Set(this.state.totalSearchedDataPieces.map((row) => row[this.IDName])) : new Set(selectedRow ? [selectedRow[this.IDName]] : []);
		const data = this.state.fullDataSet.map((row) => {
			if (!rowIdsToReplace.has(row[this.IDName])) {
				return row;
			}

			const updatedRow = { ...row, isEdited: true };
			if (this.state.dataKeyToFind.type === "select") {
				updatedRow[this.state.dataKeyToFind.name] = this.state.replacementDataValue.label;
			} else if (this.state.dataKeyToFind.type === "freeform") {
				updatedRow[this.state.dataKeyToFind.name] = updatedRow[this.state.dataKeyToFind.name]?.replaceAll(
					this.state.dataValueToFind.label,
					this.state.replacementFreeformValue
				);
			}

			return updatedRow;
		});

		this.setState({ fullDataSet: data }, () => {
			this.props.replaceData(this.state.fullDataSet, true);
			const totalSearchedDataPieces = [];
			this.state.fullDataSet.forEach((dataPiece) => {
				if (this.state.dataValueToFind.label !== "(null)") {
					if (this.state.dataKeyToFind.type == "select") {
						// match entire string for dropdown-driven find/replace
						if (dataPiece[this.state.dataKeyToFind.name] === this.state.dataValueToFind.label) {
							totalSearchedDataPieces.push(dataPiece);
						}
					} else {
						// match substrings for freeform-driven find/replace
						if (dataPiece[this.state.dataKeyToFind.name]?.includes(this.state.dataValueToFind.label)) {
							totalSearchedDataPieces.push(dataPiece);
						}
					}
				} else if (Object.keys(dataPiece).length > 0) {
					if (dataPiece[this.state.dataKeyToFind.name] === "" || !dataPiece[this.state.dataKeyToFind.name]) {
						totalSearchedDataPieces.push(dataPiece);
					}
				}
			});
			this.setState(
				{
					searchNotFound: totalSearchedDataPieces.length === 0,
					totalSearchedDataPieces,
					indexOfCurrentFoundValue: 0
				},
				() => {
					if (totalSearchedDataPieces.length > 0) {
						TableHelper.clearHighlightedCells(this.props.hierarchyLevel);
						totalSearchedDataPieces.forEach((data) => {
							TableHelper.highlightCell(this.props.hierarchyLevel, data.UniqueID, this.state.dataKeyToFind?.name);
						});
						if (reapplyHighlightAfterFirstReplace) {
							setTimeout(() => {
								totalSearchedDataPieces.forEach((data) => {
									TableHelper.highlightCell(this.props.hierarchyLevel, data.UniqueID, this.state.dataKeyToFind?.name);
								});
							}, 1000);
						}
						this.findMatchingValue();
					} else {
						TableHelper.clearHighlightedCells(this.props.hierarchyLevel);
						this.setState({ replacementDataValue: null, replacementFreeformValue: "" });
					}
				}
			);
		});
	};

	render() {
		return (
			<Modal
				id={`${this.props.hierarchyLevel}_find_replace_modal`}
				className="find_replace_modal"
				heading="Find and Replace"
				isOpen={this.state.open}
				onRequestClose={this.modalCloseCheck}
				onClick={() => {}}
				actionSetProps={{
					actionsRight: (
						<>
							<Button
								display="text"
								disabled={this.checkIfReplaceEmpty()}
								onClick={() => {
									this.replaceValue(false);
								}}
								data-tracking-id-alt="replace-value"
							>
								Replace
							</Button>
							<Button
								display="secondary"
								disabled={this.checkIfReplaceEmpty()}
								onClick={() => {
									this.replaceValue(true);
								}}
								data-tracking-id-alt="replace-all"
							>
								Replace All
							</Button>
							<Button
								display="primary"
								disabled={this.state.dataValueToFind === null || this.state.searchNotFound === true}
								onClick={() => this.findMatchingValue(true)}
								data-tracking-id-alt="find-value"
							>
								Find
							</Button>
						</>
					),
					actionsLeft: (
						<Button display="secondary" onClick={this.modalCloseCheck} data-tracking-id-alt="cancel-find-replace">
							Cancel
						</Button>
					)
				}}
			>
				{this.state.loading && <LoadingIcon />}
				<Dropdown
					className="select_data_key"
					placeholder="Select"
					required={true}
					isClearable={true}
					options={this.filterOutSelectedValue(this.state.selectableDataKeys, "selectableDataKeys") || []}
					value={this.state.dataKeyToFind}
					onChange={this.selectDataKey}
					isSearchable={true}
				>
					Data Key
				</Dropdown>
				<div className="find_replace_actions">
					{this.state.dataKeyToFind === null || this.state.dataKeyToFind.type === "select" ? (
						<Dropdown
							placeholder="Select"
							required={true}
							isClearable={true}
							options={this.filterOutSelectedValue(this.state.searchableDataValues, "searchableDataValues") || []}
							isDisabled={this.state.dataKeyToFind === null}
							value={this.state.dataValueToFind}
							onChange={this.searchDataValue}
							isSearchable={true}
						>
							Find
						</Dropdown>
					) : (
						<Textbox
							required={true}
							value={this.state.dataValueToFind?.label || ""}
							onChange={(evt, value) => {
								this.searchDataValue({ label: value, value });
							}}
						>
							Find
						</Textbox>
					)}
					{this.state.dataKeyToFind === null || this.state.dataKeyToFind.type === "select" ? (
						<Dropdown
							required={true}
							placeholder="Select"
							isClearable={true}
							options={this.filterOutSelectedValue(this.state.replaceableDataValues, "searchableReplacementDataValues") || []}
							value={this.state.replacementDataValue}
							onChange={(value) => {
								this.setState({ replacementDataValue: value });
							}}
							isDisabled={this.state.dataValueToFind === null || this.state.searchNotFound === true}
							isSearchable={true}
						>
							Replace with
						</Dropdown>
					) : (
						<Textbox
							required={true}
							disabled={this.state.dataValueToFind === null || this.state.searchNotFound === true}
							value={this.state.replacementFreeformValue}
							onChange={(evt, value) => {
								this.setState({ replacementFreeformValue: value });
							}}
						>
							Replace with
						</Textbox>
					)}
				</div>
				{this.state.dataValueToFind && (
					<div className="matching_values_count">
						{this.state.totalSearchedDataPieces.length ? this.state.indexOfCurrentFoundValue + 1 : 0}/{this.state.totalSearchedDataPieces.length} Results
					</div>
				)}
			</Modal>
		);
	}
}

export default FindReplaceModal;

// Need to handle disabling buttons, moving modal
